import React from 'react'

type FlipCardProps = {
  frontContent: React.ReactNode
  backContent: React.ReactNode
}

const FlipCard = ({ frontContent, backContent }: FlipCardProps) => {
  return (
    <div className="group h-[27rem] w-[25rem] max-w-[90%] [perspective:1000px]">
      <div className="relative h-full w-full shadow-xl transition-all duration-500 [transform-style:preserve-3d] group-hover:[transform:rotateY(180deg)]">
        {/* Front */}
        <div className="absolute inset-0 h-full w-full [backface-visibility:hidden]">
          {frontContent}
        </div>

        {/* Back */}
        <div className="absolute inset-0 overflow-hidden h-full w-full [transform:rotateY(180deg)] [backface-visibility:hidden]">
          {backContent}
        </div>
      </div>
    </div>
  )
}

export default FlipCard
